import { render, staticRenderFns } from "./bf-ppc-lp.vue?vue&type=template&id=14a5e526&scoped=true&"
import script from "./bf-ppc-lp.vue?vue&type=script&lang=js&"
export * from "./bf-ppc-lp.vue?vue&type=script&lang=js&"
import style0 from "./bf-ppc-lp.vue?vue&type=style&index=0&id=14a5e526&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a5e526",
  null
  
)

export default component.exports